/* tslint:disable */
/* eslint-disable */
/**
 * Location check service API
 * Service to centralise business area handling for multiple depending services.
 *
*/

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LocationCheckResult
 */
export interface LocationCheckResult {
    /**
     * 
     * @type {boolean}
     * @memberof LocationCheckResult
     */
    inZone?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LocationCheckResult
     */
    inPrebookingExtendedArea?: boolean;
}

/**
 * Check if a given object implements the LocationCheckResult interface.
 */
export function instanceOfLocationCheckResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LocationCheckResultFromJSON(json: any): LocationCheckResult {
    return LocationCheckResultFromJSONTyped(json, false);
}

export function LocationCheckResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocationCheckResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'inZone': !exists(json, 'inZone') ? undefined : json['inZone'],
        'inPrebookingExtendedArea': !exists(json, 'inPrebookingExtendedArea') ? undefined : json['inPrebookingExtendedArea'],
    };
}

export function LocationCheckResultToJSON(value?: LocationCheckResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'inZone': value.inZone,
        'inPrebookingExtendedArea': value.inPrebookingExtendedArea,
    };
}

